import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { Form, Row, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { Switch } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useDelayed } from '../../../hooks/useDelayed';
import { CheckBoxParam } from '../../../_lib/Form2';
import { SwitchModifier } from '../../../_lib/Form2/elements/Switch/Switch';

export type AttributeGroupPropertiesEditViewData = {
  form: SonForm<CheckBoxParam<'forFastSelection'>>;
};

function AttributeGroupPropertiesEditViewContent({ form }: AttributeGroupPropertiesEditViewData) {
  const { t } = useSonTranslation('AttributeGroups');
  const { refresh } = useRefreshBlock();
  const delayedRefresh = useDelayed(refresh);

  const { formProps, params, fetchState } = useForm({ form, onSuccess: delayedRefresh });

  const forFastSelectionParam = params.findByName('forFastSelection');

  return (
    <Form {...formProps}>
      {forFastSelectionParam && (
        <Row>
          <Switch
            label={t('properties.fastSelection.label')}
            param={forFastSelectionParam}
            modifierLabel={[SwitchModifier.POSITION_INHERIT]}
          />
        </Row>
      )}
      <SubmitButton
        buttonLabel={t('properties.form.submitButton')}
        messageSuccess={t('properties.form.status.success')}
        messageSending={t('properties.form.status.sending')}
        messageFail={t('properties.form.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}

export const AttributeGroupPropertiesEditView = asView(AttributeGroupPropertiesEditViewContent);
export type AttributeGroupPropertiesEditView = ComponentProps<typeof AttributeGroupPropertiesEditView>;
